import { useEffect, useState } from "react";
import { api } from "@/api/client";

export function usePipelineMeta() {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    api.get("/pipeline/meta").then(({ data }) => setMeta(data)).catch(() => {});
  }, []);
  return meta;
}

const ACRONYMS = { cdc: "CDC", coc: "COC", gmdss: "GMDSS", ecdis: "ECDIS", bst: "BST", pscrb: "PSCRB", aff: "AFF", mfa: "MFA",
  ifsc: "IFSC", swift: "SWIFT", nri: "NRI", nok: "NOK", us: "US", dob: "DOB", indos: "INDoS" };
export const checkLabel = (k) => k.replace(/^check_/, "").split("_").map((w) => ACRONYMS[w] || w[0].toUpperCase() + w.slice(1)).join(" ");

const STAGE_CLS = {
  Sourcing: "bg-slate-100 text-slate-700", "Docs Verification": "bg-sky-50 text-sky-700", Shortlisted: "bg-cyan-50 text-cyan-800",
  "Interview Scheduled": "bg-amber-50 text-amber-800", "Interview Passed": "bg-lime-50 text-lime-800",
  "SEA Generated": "bg-indigo-50 text-indigo-700", "Offer Sent": "bg-violet-50 text-violet-700",
  Joined: "bg-emerald-50 text-emerald-700", Rejected: "bg-rose-50 text-rose-700",
};
export function StageBadge({ stage, testid }) {
  return <span data-testid={testid} className={`inline-flex px-2 py-0.5 rounded-full text-[11px] font-medium whitespace-nowrap ${STAGE_CLS[stage] || ""}`}>{stage}</span>;
}

export function ChecklistPill({ done, total, testid }) {
  const cls = done === total ? "bg-emerald-50 text-emerald-700 border-emerald-200" : "bg-amber-50 text-amber-800 border-amber-200";
  return <span data-testid={testid} className={`inline-flex px-2 py-0.5 rounded-full border text-[11px] font-mono font-semibold ${cls}`}>{done}/{total}</span>;
}

const DOC_CLS = {
  expired: ["Expired", "bg-red-900 text-white border-red-900"], expiring: ["Expiring Soon", "bg-amber-50 text-amber-800 border-amber-200"],
  valid: ["Valid", "bg-emerald-50 text-emerald-700 border-emerald-200"], missing: ["No expiry", "bg-slate-100 text-slate-600 border-slate-200"],
  none: ["No docs", "bg-slate-100 text-slate-500 border-slate-200"],
};
export function DocStatusBadge({ status, testid }) {
  const [l, c] = DOC_CLS[status] || DOC_CLS.none;
  return <span data-testid={testid} className={`inline-flex px-2 py-0.5 rounded-full border text-[11px] font-semibold whitespace-nowrap ${c}`}>{l}</span>;
}

export async function openBlob(path) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
